<template>
<div class="bbOrderList">
    <div class="filters">
        <div class="add">
            <el-dropdown>
                <span class="el-dropdown-link">
                    <el-button type="primary">导出订单 <i class="el-icon-arrow-down"></i></el-button>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="handleExport">按订单导出</el-dropdown-item>
                    <el-dropdown-item @click.native="handleExportGoods">按商品导出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <!--<el-button type="success" @click="handleExport">按订单导出</el-button>-->
            <!--<el-button type="success" @click="handleExportGoods" plain>按商品导出</el-button>-->
            <el-button type="success" @click="handleAllWriteoff" v-if="param.status==2" style="margin-left: 20px">批量核销</el-button>
            <el-dropdown v-if="param.status==1">
                <span class="el-dropdown-link">
                     <el-button type="success" style="margin-left: 20px">批量发货 <i class="el-icon-arrow-down"></i></el-button>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="handleAllShip">直接发货</el-dropdown-item>
                    <el-dropdown-item @click.native="handleImport">导入发货文件</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <!--<el-button type="primary" @click="handleAllShip"  v-if="param.status==1">批量发货</el-button>-->
            <!--<el-button type="warning" @click="handleImport"  v-if="param.status==1">导入批量发货</el-button>-->
        </div>
        <div class="search">
            <el-date-picker value-format="yyyy-MM-dd"
                            v-model="timeSlot"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>
            <!--&lt;!&ndash;<el-input v-model="param.orderno" placeholder="订单号" class="condition" clearable></el-input>&ndash;&gt;-->
            <el-input v-model="param.title" placeholder="活动名称" class="condition" clearable></el-input>
            <el-input v-model="param.key" placeholder="用户/团长/分销员" class="condition" clearable></el-input>
            <!--<el-input v-model="param.customername" placeholder="用户昵称" class="condition" clearable></el-input>-->
            <!--<el-input v-model="param.rolehostname" placeholder="团长名称" class="condition" clearable></el-input>-->
            <!--<el-input v-model="param.parentusername" placeholder="分销员名称" class="condition" clearable></el-input>-->
            <!--<el-select v-model="param.status " placeholder="全部类型" class="condition" clearable v-if="!param.status">-->
                <!--<el-option v-for="item in statusList" :key="item.code" :label="item.name"-->
                           <!--:value="item.code"></el-option>-->
            <!--</el-select>-->
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%" ref="multipleTable"
                  @select="handleSelectionChange" @select-all="handleAllSelectionChange"  @row-click="handleRowChange">
            <el-table-column type="selection" width="50px" v-if="['1','2'].indexOf(param.status)>-1"></el-table-column>
            <el-table-column prop="voucherid" label="订单号" class-name="center" min-width="120px"></el-table-column>
            <el-table-column prop="subject" label="用户信息" min-width="120px" class-name="title">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.userlogo " :alt="scope.row.username"
                             preview="bbOrderList">
                        <span>{{scope.row.username }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="eventname" label="活动名称" class-name="center" min-width="250px"></el-table-column>
            <el-table-column prop="ordermoney " label="支付金额" class-name="center" min-width="80px">
                <template slot-scope="scope">￥{{scope.row.ordermoney}}</template>
            </el-table-column>
            <el-table-column prop="rolehostname" label="团长名称" class-name="center" min-width="80"></el-table-column>
            <el-table-column prop="recommentheadername" label="推荐团长" class-name="center" min-width="120px"></el-table-column>
            <el-table-column prop="parentusername" label="分销员" class-name="center" min-width="120px"></el-table-column>
            <el-table-column prop="ordermoney " label="分销佣金" class-name="center" min-width="80px">
                <template slot-scope="scope">￥{{scope.row.parentusermoney}}</template>
            </el-table-column>
            <el-table-column prop="datatime" label="订单时间" class-name="center" min-width="120px"></el-table-column>
            <el-table-column prop="brokeragerateheader" label="订单状态" class-name="center">
                <template slot-scope="scope">
                    <span :class="status(scope.row.status)">{{scope.row.statusname}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="100px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn" v-if="scope.row.status==31">
                            <el-button @click.stop="handleWriteoff(scope.row)" type="text" size="small">核销</el-button>
                        </span>
                        <span class="separator-btn" v-if="scope.row.status==32">
                            <el-button @click.stop="handleShip(scope.row)" type="text" size="small">发货</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click.stop="handleView(scope.row)" type="text" size="small">详情</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                       :page-size="page.pageSize"
                       :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
    <shipDialog ref="shipDialog" @refresh="refresh"></shipDialog>
    <shipsDialog ref="shipsDialog" @refresh="refresh"></shipsDialog>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getOrderList, getExportOrderList, uploadOrderCheckResult, getExportOrderByProductList} from 'api/brandBusiness'
import {brandBusiness} from 'api/enumCode'
import {dateFormat} from 'common/js/tools'
import ShipDialog from 'views/brandBusiness/activityMgt/order/components/shipDialog.vue'
import ShipsDialog from 'views/brandBusiness/activityMgt/order/components/shipsDialog.vue'
export default {
    name: 'bbOrderList',
    data() {
        return {
            visible: false,
            visible2: false,
            tableData: [],
            init: false,
            total: 0,
            statusList: brandBusiness.orderStatus,
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            timeSlot: null,
            param: {
                begintime: '',
                customername: '',
                eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                endtime: '',
                orderno: '',
                status: '',
                title: '',
                rolehostname: '',
                parentusername: '',
                key: ''
            },
            selectedId: []
        }
    },
    mounted() {
    },
    methods: {
        initParam() {
           this.param =  {
               begintime: '',
               customername: '',
               eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
               endtime: '',
               orderno: '',
               status: '',
               title: '',
               rolehostname: '',
               parentusername: '',
               key: ''
           }
            this.page.page = 1
            this.timeSlot = null
            this.selectedId = []
            this.init = false
        },
        handleImport() {
            this.$refs.shipsDialog.openDialog()
        },
        handleView(row) {
            this.$router.push({name: 'BBOrderView', query: {orderno: row.voucherid, eventid: row.eventid}})
        },
        handleSelectionChange(selection, row) {
            this.selectedId = selection
        },
        handleAllSelectionChange(selection) {
            this.handleSelectionChange(selection)
        },
        handleRowChange(row, column, event) {
            let flag = false
            this.selectedId.forEach((obj, i) => {
                if (row.voucherid == obj.voucherid) {
                    this.$refs.multipleTable.toggleRowSelection(row, false)
                    this.selectedId.splice(i, 1)
                    flag = true
                }
            })
           if (!flag) {
               this.$refs.multipleTable.toggleRowSelection(row)
               this.selectedId.push(row)
           }
        },
        handleAllWriteoff() {
            if (!this.selectedId.length) {
                this.$message.error('请选择订单核销')
                return false
            }
            this.$confirm(`确认核销${this.selectedId.length}个订单`, '提示', {
                confirmButtonText: '确认核销',
                showCancelButton: false
            }).then(() => {
                let orderno = []
                this.selectedId.forEach(obj => {
                    orderno.push(obj.voucherid)
                })
                let obj = {
                    checkusertype: 1,
                    eventtype: 10,
                    orderno: orderno.join(',')
                }
                this._writeoff(obj)
            })
        },
        handleWriteoff(row) {
            this.$confirm(`确认核销该订单`, '提示', {
                confirmButtonText: '确认核销',
                showCancelButton: false
            }).then(() => {
                let obj = {
                    checkusertype: 1,
                    eventtype: 10,
                    orderno: row.voucherid
                }
                this._writeoff(obj)
            })
        },
        handleAllShip() {
            if (!this.selectedId.length) {
                this.$message.error('请选择订单发货')
                return false
            }
            let orderno = []
            this.selectedId.forEach(obj => {
                orderno.push(obj.voucherid)
            })
            this.$refs.shipDialog.openDialog({type: 1, orderno: orderno})
        },
        handleShip(row) {
            this.$refs.shipDialog.openDialog({type: 2, orderno: [row.voucherid]})
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        handleExport() {
            if (this.timeSlot) {
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            this.setLoading(true)
            getExportOrderList({
                data: Object.assign({}, this.param),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '订单-按订单导出' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleExportGoods() {
            if (this.timeSlot) {
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            this.setLoading(true)
            getExportOrderByProductList({
                data: Object.assign({}, this.param),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '订单-按商品导出' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        refresh() {
            this.$emit('getList')
        },
        _refresh(status) {
            this.param.status = status
            this._getList()
        },
        getList(status) {
            this.param.status = status
            if (!this.init) this._getList()
        },
        _writeoff(obj) {
            this.setLoading(true)
            uploadOrderCheckResult({
                data: Object.assign({}, obj),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('核销成功')
                    this.$emit('getList')
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList() {
            if (this.timeSlot) {
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            this.setLoading(true)
            getOrderList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    if (this.page.page > 1 && this.page.page > data.data.pageinfo.pagecount) {
                        this.page.page = data.data.pageinfo.pagecount
                        this._getList()
                    } else {
                        this.tableData = data.data.orderlist
                        this.total = data.data.pageinfo.datacount
                        this.init = true
                        this.setLoading(false)
                    }
                    this.selectedId = []
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {
        ...mapGetters(['params',])
    },
    computed: {
        status() {
            return function (value) {
                for (let i = 0; i < brandBusiness.orderStatus.length; i++) {
                    if (value === brandBusiness.orderStatus[i].code) {
                        return brandBusiness.orderStatus[i].cls
                    }
                }
                return value
            }
        }
    },
    components: {
        ShipDialog, ShipsDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.bbOrderList {
    .filters{
        .add{
            display: flex;
            flex-wrap: nowrap;
            margin-right: 20px;
        }
        .search{
            display: flex;
            .el-input{
                margin-right: 20px;
                width: 156px;
                input{
                    width: 100%;
                }
            }
            .el-select{
               width: 100px;
                .el-input{
                    width: 100%;
                }
            }
            .el-date-editor .el-range-separator{
                 line-height: 28px;
             }
            .el-range-editor.el-input__inner{
                  width: 240px;
                  margin-right: 20px;
              }
        }
    }
    .imageText{
        display: flex;
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .el-pagination{
        margin-top: 20px;
        text-align: center;
    }
}
</style>
